import { cva } from 'class-variance-authority';

const stepperKnobIndicatorStyles = [
  'h-3',
  'aspect-square',
  'rounded-full',
  'flex',
  'items-center',
  'justify-center',
  'cursor-pointer',
];

const stepperKnobIndicatorStylesSAG = cva([
  ...stepperKnobIndicatorStyles,
  'data-[status=done]:bg-[#007993]',
  'dark:data-[status=done]:bg-[#00CCCC]',
  'data-[status=error]:bg-[#D72339]',
  'dark:data-[status=error]:bg-[#FF7687]',
  'data-[status=active]:bg-[#005159]',
  'dark:data-[status=active]:bg-[#00FFB9]',
  'data-[status=default]:bg-[#4C4C68]',
  'dark:data-[status=default]:bg-[#B3B3BE]',
  'data-[status=disabled]:bg-[#B3B3BE]',
  'dark:data-[status=disabled]:bg-[#737389]',
]);

const stepperKnobIndicatorStylesSHS = cva([
  ...stepperKnobIndicatorStyles,
  'data-[status=done]:bg-[#cf4b00]',
  'dark:data-[status=done]:bg-[#cf4b00]',
  'data-[status=error]:bg-[#e7001d]',
  'dark:data-[status=error]:bg-[#e7001d]',
  'data-[status=active]:bg-[#ec6602]',
  'dark:data-[status=active]:bg-[#ec6602]',
  'data-[status=default]:bg-[#666666]',
  'dark:data-[status=default]:bg-[#ffffff]',
  'data-[status=disabled]:bg-[#ededed]',
  'dark:data-[status=disabled]:bg-[#ededed]',
]);

export { stepperKnobIndicatorStylesSAG, stepperKnobIndicatorStylesSHS };
